import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorLog, ErrorLogListParams, ErrorLogListResponse } from '../../models/error-log.model';

interface ErrorLogState {
    data: ErrorLog[];
    page: number;
    per_page: number;
    total: number;
    loading: boolean;
}

const initialState: ErrorLogState = {
    data: [],
    page: 1,
    per_page: 10,
    total: 0,
    loading: false
};

const errorLogSlice = createSlice({
    name: 'errorLog',
    initialState,
    reducers: {
        getErrorLogs: {
            reducer: (state, action: PayloadAction<Partial<ErrorLogListParams> | undefined>) => {
                state.loading = true;
                if (action.payload?.page) {
                    state.page = action.payload.page;
                }
                if (action.payload?.per_page) {
                    state.per_page = action.payload.per_page;
                }
            },
            prepare: (params?: Partial<ErrorLogListParams>) => ({ payload: params })
        },
        getErrorLogsSuccess: (state, action: PayloadAction<ErrorLogListResponse>) => {
            state.data = Array.isArray(action.payload?.data) ? action.payload.data : [];
            state.total = Number(action.payload?.total || 0);
            state.page = Number(action.payload?.page || state.page || 1);
            state.per_page = Number(action.payload?.per_page || state.per_page || 10);
            state.loading = false;
        },
        getErrorLogsFailed: (state) => {
            state.loading = false;
        },
        dismissErrorLog: {
            reducer: (state) => {
                state.loading = true;
            },
            prepare: (id: string) => ({ payload: id })
        },
        dismissErrorLogSuccess: (state) => {
            state.loading = false;
        },
        dismissErrorLogFailed: (state) => {
            state.loading = false;
        },
        dismissAllErrorLogs: (state) => {
            state.loading = true;
        },
        dismissAllErrorLogsSuccess: (state) => {
            state.data = [];
            state.total = 0;
            state.page = 1;
            state.loading = false;
        },
        dismissAllErrorLogsFailed: (state) => {
            state.loading = false;
        }
    }
});

export const {
    getErrorLogs,
    getErrorLogsSuccess,
    getErrorLogsFailed,
    dismissErrorLog,
    dismissErrorLogSuccess,
    dismissErrorLogFailed,
    dismissAllErrorLogs,
    dismissAllErrorLogsSuccess,
    dismissAllErrorLogsFailed
} = errorLogSlice.actions;

export default errorLogSlice.reducer;
